import { useQuery } from "@apollo/client";

import {
    GetLegacyNextAssetOwnershipQuery,
    GetLegacyNextAssetOwnershipQueryVariables,
} from "graphql-types/graphql";

import { GET_ASSET_OWNERSHIP } from "./use-asset-ownership.query";

export const useAssetOwnershipQuery = (assetId: string) => {
    const { data, loading } = useQuery<
        GetLegacyNextAssetOwnershipQuery,
        GetLegacyNextAssetOwnershipQueryVariables
    >(GET_ASSET_OWNERSHIP, {
        variables: {
            bfe: assetId,
        },
    });

    return {
        data: data?.getLegacyNextAssetOwnership,
        loading,
    };
};
